/* eslint-disable react-hooks/rules-of-hooks */
/**
 * This component is used to debug Open Graph meta tags and especially images during development.
 * By default, there is no way to check you changes, you always need to manually load the page's source,
 * copy the new dynamically generated link and paste it in the browser to see the changes.
 *
 * This component will fetch the current page's source, parse it and display the Open Graph meta tags
 * as well as the generated image every 3 seconds. This way you can debug/develop images.
 *
 * This component is not meant to be used in production, it's only for development purposes.
 *
 * Simply import the component and render it anywhere on the page where you want to debug the Open Graph meta tags.
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

"use client";

import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

import { Button } from "@/components/ui/button";

const ENABLE_DEBUG_MODE = false; // Set to true to test OG meta images

export function DebugOG() {
  if (!ENABLE_DEBUG_MODE) return null;

  const [enabled, setEnabled] = useLocalStorage("debug-og", false);
  const social = "og";
  const [metaData, setMetaData] = useState(null);

  useEffect(() => {
    fetch(window.location.href)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const og = Array.from(
          doc.querySelectorAll("meta[property^='og:']"),
        ).reduce((acc, meta) => {
          acc[meta.getAttribute("property").replace("og:", "")] =
            meta.getAttribute("content");
          return acc;
        }, {});
        setTimeout(() => setMetaData({ og }), metaData ? 3000 : 0);
      })
      .catch(() =>
        setTimeout(() => setMetaData({ ...metaData }), metaData ? 3000 : 0),
      );
  }, [metaData, enabled]);

  return (
    <>
      <div className="flex justify-center gap-2 p-2">
        <div>
          <Button size="xs" onClick={() => setEnabled(!enabled)}>
            {enabled ? "Disable OG Debug" : "Enable OG Debug"}
          </Button>
        </div>
      </div>
      {enabled && (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={metaData?.[social]?.image}
            alt={metaData?.[social]?.title}
          />
          <pre className="w-full overflow-auto text-left">
            {JSON.stringify(metaData, null, 2)}
          </pre>
        </div>
      )}
    </>
  );
}
